/*注册相关路由*/
export default{
  path: '/register',
  component: resolve=>require(['@/views/main.vue'],resolve),
  children:[
    {path:'',component:resolve=>require(['@/views/register/index.vue'],resolve)}
  ]
}
